import Alert from "@mui/material/Alert";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useQueryClient } from "@tanstack/react-query";
import { Navigate } from "react-router-dom";
import { useMyOrg } from "@/hooks/use-my-org";
import { FinanceAccountSetup } from "@/components/payments/FinanceAccountSetup";

export function StripeConnectSetupPage() {
  const view = useMyOrg();
  const cache = useQueryClient();
  if (view.kind === "loading") return <CircularProgress aria-label="Loading organization" />;
  if (view.kind === "no-org") return <Navigate to="/getting-started" replace />;
  if (!view.org?.org_id) return <Alert severity="error">Select an organization to manage payments.</Alert>;
  return <Stack spacing={2.5} sx={{ px: { xs: 2, lg: 3 }, pb: 4 }}>
    <Typography component="h1" variant="h5">Payment account</Typography>
    <FinanceAccountSetup key={view.org.org_id} orgId={view.org.org_id}
      onChanged={() => { void cache.invalidateQueries({ queryKey: ["org", "me"] }); }} />
  </Stack>;
}
